import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography
} from '@mui/material';
import { CampaignResultsProps } from './types';
import { getPreviewUrl } from '~/shared/utils/uploadImage';
import { SettingsResult } from './SettingsResult';

export const CampaignResults: React.FC<CampaignResultsProps> = ({
    images,
    results,
    settings,
    budgetRange,
    suffixPreview,
    suffixPreviewHint,
}) => {
    return (
        <Card>
            <CardContent>
                <Stack spacing={2}>
                    <Box
                        sx={{
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            p: 2,
                            bgcolor: 'background.paper',
                        }}
                    > 
                        <Stack
                            direction={{ xs: 'column', lg: 'row' }}
                            spacing={2}
                            alignItems="flex-start"
                        >
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <SettingsResult
                                    settings={settings}
                                    budgetRange={budgetRange}
                                    suffixPreview={suffixPreview}
                                    suffixPreviewHint={suffixPreviewHint}
                                />
                            </Box>
                            {images.length > 0 && (
                                <Box
                                    sx={{
                                        width: { xs: '100%', lg: 180 },
                                        flexShrink: 0,
                                    }}
                                >
                                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                        Превью изображений
                                    </Typography>
                                    <Stack direction="row" gap={1} flexWrap="wrap" justifyContent="flex-start">
                                        {images.map((img, index) => {
                                            const src = img?.src ? img.src : getPreviewUrl(img);
                                            if (!src) return null;
                                            return (
                                                <Stack
                                                    key={index}
                                                    flexDirection="column"
                                                    alignItems="center"
                                                    justifyContent="flex-start"
                                                    spacing={0.5}
                                                >
                                                    <img
                                                        src={src}
                                                        width={40}
                                                        height={40}
                                                        style={{ borderRadius: '6px', objectFit: 'cover' }}
                                                    />
                                                    <Typography variant="caption">{index + 1}</Typography>
                                                </Stack>
                                            );
                                        })}
                                    </Stack>
                                </Box>
                            )}
                        </Stack>
                    </Box>

                    <Box>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Будут созданы кампании:
                        </Typography>
                        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 420 }}>
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    <TableCell>Аккаунт</TableCell>
                                    <TableCell>Домен</TableCell>
                                    <TableCell align="right">Бюджет $</TableCell>
                                    <TableCell align="right">Итоговый бюджет</TableCell>
                                    <TableCell align="right">Курс</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {results.map((result, index) => (
                                    <TableRow key={`${result.account.id}-${result.domain.id}`} hover>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{result.account.name}</TableCell>
                                        <TableCell>{result.domain.name}</TableCell>
                                        <TableCell align="right">
                                            {result.budget_preview
                                                ? `${result.budget_preview.selected_budget_usd} USD`
                                                : '—'}
                                        </TableCell>
                                        <TableCell align="right">
                                            {result.budget_preview
                                                ? `${result.budget_preview.final_budget} ${result.budget_preview.currency_code}`
                                                : '—'}
                                        </TableCell>
                                        <TableCell align="right">
                                            {result.budget_preview
                                                ? Number(result.budget_preview.exchange_rate).toFixed(4)
                                                : '—'}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    </Box>
                </Stack>
            </CardContent>
        </Card>
    );
};
